import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import MegaMenu from "./megamenu";
import { DfpAd } from "../../atoms/dfp-ad";
import HeaderBrandRow from "./header-brand-row";
import assetify from "@quintype/framework/assetify";
import logo from "../../../../assets/images/gaming-logo.png";
import homeIcon from "../../../../assets/images/vikatan-homeicon.png";
import styles from "./gamestyles.m.css";
import { LoadingIndicatorComponent } from "../../atoms/loading-indicator";
import { Link } from "@quintype/components";
import { checkAppSlug } from "../../utils/utils";

class GameHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMegaMenuOpen: false,
      isSearchOpen: false,
      loginData: {}
    };
  }

  render() {
    if (checkAppSlug()) {
      return false;
    }

    return (
      <React.Fragment>
        <LoadingIndicatorComponent />
        <header className={styles.gameheader}>
          <Link aria-label="Vikatan" href={"/gaming"} disableAjaxLinks={true}>
            <img src={assetify(logo)} alt="" className={styles["logo"]} />
          </Link>
          <div className={styles["header-ad"]}>
            <DfpAd adtype="Large_Leaderboard" placement="all" />
          </div>
          <a href="https://www.vikatan.com?p_from=Gamezop" className={styles["header-btn"]}>
            <img src={assetify(homeIcon)} alt="" />
          </a>
        </header>
      </React.Fragment>
    );
  }
}

GameHeader.propTypes = {
  menuGroup: MegaMenu.propTypes.menuGroup,
  appStoreLinks: MegaMenu.propTypes.appStoreLinks,
  socialLinks: MegaMenu.propTypes.socialLinks,
  latestIssues: MegaMenu.propTypes.latestIssues,
  subscriptionLink: HeaderBrandRow.propTypes.subscriptionLink,
  pageLoading: PropTypes.bool,
  addUser: PropTypes.func,
  vikatanHosts: HeaderBrandRow.propTypes.vikatanHosts
};

function mapStateToProps(state) {
  const data = get(state, ["qt", "data", "header"]);
  const pageLoading = get(state, ["pageLoading"], false);
  const vikatanHosts = get(state, ["qt", "config", "vikatanHosts"]);
  return data ? { ...data, pageLoading, vikatanHosts } : {};
}

export default connect(mapStateToProps)(GameHeader);
